import { defineMessages } from 'react-intl';
import { ReportCardType } from '../DashboardCards/ReportCard/ReportCard.types';

export default defineMessages({
  [ReportCardType.ACCOUNT]: { id: 'report.overview.reportType.Account', defaultMessage: 'Account' },
  [ReportCardType.SITE]: { id: 'report.overview.reportType.Site', defaultMessage: 'Site' },
  [ReportCardType.ADUNIT]: { id: 'report.overview.reportType.AdUnit', defaultMessage: 'Ad Unit' },
  [ReportCardType.TYPE_TAG]: { id: 'report.overview.reportType.TypeTag', defaultMessage: 'Type Tag' },
  [ReportCardType.PTQs]: { id: 'report.overview.reportType.PTQsSnapshot', defaultMessage: 'PTQS' },
  [ReportCardType.distributionV2]: { id: 'report.overview.reportType.DistributionV2', defaultMessage: 'Distribution V2' },
  [ReportCardType.DistributionPartnerTagV2]: {
    id: 'report.overview.reportType.DistributionPartnerTagV2',
    defaultMessage: 'Distribution Partner Tag V2',
  },
  [ReportCardType.DistributionPTQS]: { id: 'report.overview.reportType.DistributionPTQS', defaultMessage: 'Distribution PTQS' },
  [ReportCardType.DistributionPTQSSnapshot]: {
    id: 'report.overview.reportType.DistributionPTQSSnapshot',
    defaultMessage: 'Distribution PTQS Snapshot',
  },
  title: { id: 'report.newReport.overview.title', defaultMessage: 'Overview' },
});
